module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Manuela Improta — Saúde mental para mulheres","short_name":"Manuela Improta","description":"Psicoterapia online para mulheres: ansiedade, autocobrança e relacionamentos. Acompanhamento perinatal para tentantes, gestantes e puérperas.","lang":"pt-BR","start_url":"/","background_color":"#fbf8f3","theme_color":"#c97b5c","display":"standalone","icon":"src/images/icon-manifest.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"55e50408d232a4a4fc3c855bdea831c5"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
